import React, { FC, useCallback } from 'react';
import {useIntl} from "react-intl";
import { List, BarChart3, PieChart, Calendar, Grid3X3 } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "../../../../ui/tabs";
import {trackEvent} from "../../../../../utils/analytics";

export const getViewSwitchOptions = (formatMessage: any) => ([
  {
    label: formatMessage({ id: 'HISTORY' }),
    key: 'History',
    icon: <List className="h-4 w-4" />
  },
  {
    label: formatMessage({ id: 'CALENDAR' }),
    key: 'Calendar',
    icon: <Calendar className="h-4 w-4" />
  },
  {
    label: 'Blocky',
    key: 'Blocky',
    icon: <Grid3X3 className="h-4 w-4" />
  },
  {
    label: formatMessage({ id: 'GROUPED' }),
    key: 'Summary',
    icon: <BarChart3 className="h-4 w-4" />
  },
  {
    label: formatMessage({ id: 'TOTAL' }),
    key: 'Total',
    icon: <PieChart className="h-4 w-4" />
  }
]);

interface IViewSwitch {
  setView: React.Dispatch<string>
  view: string
}
export const ViewSwitch: FC<IViewSwitch> = ({ setView, view }) => {
  const { formatMessage } = useIntl();
  const onChange = useCallback((e: string) => {
    trackEvent('view_change');
    setView(e);
  }, [setView]);

  const items = getViewSwitchOptions(formatMessage);

  return (
    <Tabs value={view} onValueChange={onChange}>
      <TabsList>
        {items.map((item) => (
          <TabsTrigger key={item.key} value={item.key} title={item.label}>
            {item.icon}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
